import Draggable from './Draggable.vue'

export default Draggable
